<template>
  <el-row :gutter="gutter" class="chinaAddr" ref="address">
		<el-col :sm="country=='1'?8:12" :xs="24">
			<label class="form-title">{{$i18n.locale=='zh'?(country=='1'?'省':'区/域'):(country=='1'?'省':'區/域')}}</label>
			<el-form-item prop="zone">
				<el-select v-model="province" :placeholder="$i18n.locale=='zh'?'请选择':'請選擇'" class="selectBox" @change="changeProvince_CH">
					<!--中国省列表-->
					<el-option class="selectList" v-for="it in chinaAddress" :key="it.name" :value="it.name" v-if="country=='1'"></el-option>
					<!--中国香港区域列表-->
					<el-option class="selectList" v-for="it in HK_Address" :key="it.name" :value="it.name" v-if="country=='0'"></el-option>
				</el-select>
			</el-form-item>
		</el-col>
		<el-col :sm="country=='1'?8:12" :xs="24" v-if="showCity">
			<label class="form-title">{{$i18n.locale=='zh'?(country=='1'?'市':'区'):(country=='1'?'市':'區')}}</label>
			<el-form-item prop="district">
				<el-select v-model="city" :placeholder="$i18n.locale=='zh'?'请选择':'請選擇'" class="selectBox" @change="changeCity_CH">
					<!--中国市列表-->
					<template v-for="(it,index) in chinaAddress" v-if="it.name==province&&country=='1'">
						<el-option class="selectList" v-for="(its,indexs) in it.cityList" :key="its.name" :value="its.name"></el-option>
					</template>
					<!--中国香港区列表-->
					<template v-for="(it,index) in HK_Address" v-if="it.name==province&&country=='0'">
						<el-option class="selectList" v-for="(its,indexs) in it.cityList" :key="its" :value="its"></el-option>
					</template>
				</el-select>
			</el-form-item>
		</el-col>
		<el-col :sm="8" :xs="24" v-if="showArea&&country=='1'">
			<label class="form-title">{{$i18n.locale=='zh'?'县':'縣'}}</label>
			<el-form-item prop="area">
				<el-select v-model="area" :placeholder="$i18n.locale=='zh'?'请选择':'請選擇'" class="selectBox" @change="changeArea_CH">
					<template v-for="(it,index) in chinaAddress" v-if="it.name==province">
						<template v-for="(its,indexs) in it.cityList" v-if="its.name==city">
							<el-option class="selectList" v-for="(itss,indexss) in its.areaList" :key="itss" :value="itss"></el-option>
						</template>
					</template>
				</el-select>
			</el-form-item>
		</el-col>
  </el-row>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'addressCH',
  props: ['deliveryCountry','chinaProvince','chinaCity','chinaArea'],
  data () {
  	return {
  		province: this.chinaProvince,
  		city: this.chinaCity,
  		area: this.chinaArea,
  		showCity: true,
  		showArea: true,
  	}
  },
  computed: {
  	...mapState('param',['gutter']),
  	country () {//0是香港 1是中国内陆
  		return this.deliveryCountry
  	},
  	HK_Address () {
  		return this.$i18n.locale=='zh'?require('@/common/json/HONGKONG'):require('@/common/json/HONGKONG_hk')
  	},
  	chinaAddress () {
  		return this.$i18n.locale=='zh'?require('@/common/json/chinaArea'):require('@/common/json/chinaArea_hk')
  	}
  },
  methods: {
  	changeProvince_CH (v) {
  		let name = v,its
  		//如果是中国
  		if(this.deliveryCountry == '1'){
  			its = this.chinaAddress.filter((v,i) => {
	  			return v.name == name
	  		})
  			//如果省级下有市级，则将第一个排列的市置为select当前选中项，第一个县置为当前选中项
	  		if(its[0].cityList.length !== 0){
	  			this.city = its[0].cityList[0].name
		  		this.area = its[0].cityList[0].areaList[0]
		  		this.showCity = true
	  			this.showArea = true
	  		}else{
	  			//否则隐藏市和县
	  			this.city = ''
		  		this.area = ''
	  			this.showCity = false
	  			this.showArea = false
	  		}
			//如果是香港
  		}else if(this.deliveryCountry == '0'){
  			its = this.HK_Address.filter((v,i) => {
	  			return v.name == name
	  		})
  			//如果区域级下有区级，则将第一个排列的区置为select当前选中项
	  		if(its[0].cityList.length !== 0){
	  			this.city = its[0].cityList[0]
	  			this.area = ''//香港没有第三级area，一直为空
		  		this.showCity = true
	  		}else{
	  			//否则隐藏区
	  			this.city = ''
	  			this.area = ''
	  			this.showCity = false
	  		}
  		}
  		//console.log(its)
  		//向父级传递数据
  		this.$emit('update:chinaProvince', name)
	  	this.$emit('update:chinaCity', this.city)
	  	this.$emit('update:chinaArea', this.area)
  		//向父级传递自定义事件
  		this.$emit('change-op')
  	},
  	changeCity_CH (v) {
  		let name = v,its,itss
  		//如果是中国
  		if(this.deliveryCountry == '1'){
  			its = this.chinaAddress.filter( (v,i) => {
	  			return v.name == this.chinaProvince
	  		})
  			itss = its[0].cityList.filter( (v,i) => {
	  			return v.name == name
	  		})
  			//如果市级下有县级，则将第一个排列的县置为select当前选中项
	  		if(itss[0].areaList.length !== 0){
		  		this.area = itss[0].areaList[0]
		  		this.showArea = true
	  		}else{
	  			//否则隐藏县，值为空
	  			this.area = ''
	  			this.showArea = false
	  		}
  		}else if(this.deliveryCountry == '0'){//香港没有第三级area,所以直接置空
  			this.area = ''
  		}
  		//向父级传递数据
  		this.$emit('update:chinaCity', name)
		  this.$emit('update:chinaArea', this.area)
  		//向父级传递自定义事件
  		this.$emit('change-op')
  	},
  	changeArea_CH (v) {
  		this.$emit('update:chinaArea', v)
  		this.$emit('change-op')
  	},
  },
  //监听国家变化
  watch: {
  	//国家地区发生变化，下面省市级（区域 区等等）都清空
  	deliveryCountry (val, oldVal) {
  		if(val !== oldVal){
  			this.province = ''
  			this.city = ''
  			this.area = ''
  		}
  	}
  }
}
</script>
<style scoped lang="less">
.form-title{
	font-size: 14px;
	line-height: 14px;
    margin-bottom: 6px;
    color: #4e4e4e;
    display: inline-block;
    i{
    	margin-right: 5px;
    	color: #f56c6c;
    }
    span{
    	font-size: 12px;
    	color: #9f9f9f;
    	line-height: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/address.vue